import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";

import { createProjectNameResi } from "../../../actions/nameAction_Dwk";

import {  Form, Button } from "semantic-ui-react";
import TextInput from "../../form/TextInput";

class ProjectNameResiCreate extends Component {
  onSubmit = (values) => {
    this.props.createProjectNameResi(values);
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <div
        className="font-family-Roboto"
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        {/**/}
        <div
          className="card-attached border-radius-top "
          style={{ textAlign: "center", backgroundColor: "skyblue" }}
        >
          <div
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              padding: "10px",
            }}
          >
            {/*  */}
            Create Residential Project Name
            {/*  */}
          </div>
        </div>
        {/**/}

        {/*  */}

        <div className="card-attached border-radius-bottom pxy-20">
          <div className=" label">
            <Form onSubmit={handleSubmit(this.onSubmit)}>
              <label>Residential Project Name</label>
              <Field
                name="projectNameResi"
                type="text"
                component={TextInput}
                placeholder="Residential Project Name"
              />

              <br />

              <Button
                color="olive"
                type="submit"
                disabled={pristine || submitting}
              >
                Submit
              </Button>
              <Button
                color="orange"
                type="button"
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear Values
              </Button>
              <Button
                color="teal"
                type="button"
                onClick={() => this.props.closeModal()}
              >
                Cancel
              </Button>
            </Form>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
  };
};
export default connect(mapStateToProps, { createProjectNameResi })(
  reduxForm({
    form: "ProjectNameResiCreate", // a unique identifier for this form
    // validate
  })(ProjectNameResiCreate)
);
